exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/examineProblemDlg/src/main.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"main.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b902658","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/examineProblemDlg/src/main.vue
// module id = 420
// module chunks = 2 4